// Mapped from AmethystEvent project for better "type" safety
// https://code.amazon.com/packages/AmethystEvents/blobs/c8ac406eb1dbb5b5fbe8dc878c0c5d5e0b9004a4/--/configuration/include/com/zappos/amethyst/website/WebsiteEnums.proto#L85
// Only the ones marty uses have been put here
export const PRODUCT_PAGE = 'PRODUCT_PAGE';
export const SEARCH_PAGE = 'SEARCH_PAGE';
export const CART_PAGE = 'CART_PAGE';
export const LANDING_PAGE = 'LANDING_PAGE';
export const CART_PAGE_MODAL = 'CART_PAGE_MODAL';
export const CHECKOUT_PAGE = 'CHECKOUT_PAGE';
export const COLLECTIONS_PAGE = 'COLLECTIONS_PAGE';
export const COLLECTIONS_LIST_PAGE = 'COLLECTIONS_LIST_PAGE';
export const EXCHANGE_INITIATE_PAGE = 'EXCHANGE_INITIATE_PAGE';
export const INTERSTITIAL_ADD_TO_CART_PAGE = 'INTERSTITIAL_ADD_TO_CART_PAGE';
export const ORDER_HISTORY_PAGE = 'ORDER_HISTORY_PAGE';
export const ORDER_DETAIL_PAGE = 'ORDER_DETAIL_PAGE';
export const MY_ACCOUNT_PAGE = 'MY_ACCOUNT_PAGE';
export const QUICKVIEW_PRODUCT_MODAL_PAGE = 'QUICKVIEW_PRODUCT_MODAL_PAGE';
export const UNKNOWN_PAGE_TYPE = 'UNKNOWN_PAGE_TYPE';
export const MEDIA_UPLOAD_PAGE = 'MEDIA_UPLOAD_PAGE';
export const WRITE_PRODUCT_REVIEW_PAGE = 'WRITE_PRODUCT_REVIEW_PAGE';
export const PRODUCT_REVIEW_LIST_PAGE = 'PRODUCT_REVIEW_LIST_PAGE';
export const OUTFIT_DETAIL_PAGE = 'OUTFIT_DETAIL_PAGE';
export const INFLUENCER_COLLECTION_PAGE = 'INFLUENCER_COLLECTION_PAGE';
export const INFLUENCER_PAGE = 'INFLUENCER_PAGE';
export const INFLUENCER_HOME_PAGE = 'INFLUENCER_HOME_PAGE';
export const INFLUENCER_STOREFRONT_PAGE = 'INFLUENCER_STOREFRONT_PAGE';
export const INFLUENCER_SHOPPABLE_POSTS_PAGE = 'INFLUENCER_SHOPPABLE_POSTS_PAGE';
export const INFLUENCER_STYLE_FEED = 'INFLUENCER_STYLE_FEED';
export const OUTFIT_RECOS_QUICK_VIEW_MODAL_PAGE = 'OUTFIT_RECOS_QUICK_VIEW_MODAL_PAGE';
export const OUTFIT_RECOS_QUICK_SHOP_MODAL_PAGE = 'OUTFIT_RECOS_QUICK_SHOP_MODAL_PAGE';
export const VISUAL_SEARCH_RESULTS_PAGE = 'VISUAL_SEARCH_RESULTS_PAGE';
